export default __webpack_public_path__ + "24fe960f7d0524bc39e7ebc98532285b.svg";